const receivingType = {
	transfer: 'transfer',
	container: 'container',
};

export { receivingType };
